import React from 'react';
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function GoldenVisaSpain() {

    return (
        <main className='main'>
            <IntroSection
                title="Residency by Investment – Spain"
                subtitle="Residency by Investment in the Heart of Europe"
                description="The Spanish Golden Visa offers foreign investors the opportunity to live in Spain, travel freely within the Schengen Zone, and enjoy one of Europe’s most attractive lifestyles. With options such as real estate investment, capital transfer, or business projects, Spain’s program is ideal for entrepreneurs, investors, and families seeking mobility, stability, and EU residency benefits."
                badges={[
                    "EU Residency",
                    "Schengen Free Travel",
                    "Family Included",
                    "Path to Citizenship"
                ]}
                buttonText="Request a Golden Visa Spain Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../assets/images/residency-passport/golden-visa-spain-hero.png")}
                imageAlt="Spain Golden Visa & Residency"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose the Spanish Golden Visa?'
                        blocks={[
                            {
                                items: [
                                    { title: "Schengen Mobility", text: "Visa-free travel across 27 EU countries." },
                                    { title: "Residency & Lifestyle", text: "Live, work, or study in Spain." },
                                    { title: "Family Benefits", text: "Include spouse, children, and dependent parents." },
                                    { title: "Investment Options", text: "Real estate, capital transfer, government bonds, or business projects." },
                                    { title: "Path to Citizenship", text: "Permanent residency after 5 years and citizenship after 10 years (2 years for some Latin American nationals)." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Investment Options"
                        blocks={[
                            {
                                title: "1. Real Estate Investment",
                                items: [
                                    { text: "Purchase property worth €500,000+ (single or multiple properties)." }
                                ]
                            },
                            {
                                title: "2. Capital Investment",
                                items: [
                                    { text: "Deposit of €1 million+ in Spanish banks, shares, or investment funds." }
                                ]
                            },
                            {
                                title: "3. Government Bonds",
                                items: [
                                    { text: "Invest €2 million+ in Spanish government bonds." }
                                ]
                            },
                            {
                                title: "4. Business Project",
                                items: [
                                    { text: "Invest in innovative business projects generating jobs and economic value." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title='Key Features'
                        blocks={[
                            {
                                items: [
                                    { title: "Residency Permit", text: "Initially valid for 1 year, renewable every 2 years." },
                                    { title: "Flexible Stay", text: "No minimum stay requirement to maintain residency." },
                                    { title: "Permanent Residency", text: "Available after 5 years." },
                                    { title: "Citizenship Eligibility", text: "After 10 years, or 2 years for Ibero-American nationals." },
                                    { title: "Healthcare & Education", text: "Access to Spanish public healthcare and education systems." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Benefits of Spain’s Golden Visa"
                        services={[
                            { title: "Live in Spain", text: "Enjoy one of Europe’s most vibrant cultures and lifestyle." },
                            { title: "Schengen Travel", text: "Freedom of movement across EU countries." },
                            { title: "Family Residency", text: "Include spouse, children, and parents under the same visa." },
                            { title: "Flexible Investments", text: "Choose property, government bonds, or capital investments." },
                            { title: "Permanent Residency & Citizenship", text: "Long-term path to EU citizenship." }
                        ]}
                    />

                    <DetailsSection
                        title="Process to Apply"
                        items={
                            [
                                { text: "Consultation & Eligibility Check" },
                                { text: "Select Investment Option — real estate, capital, or bonds" },
                                { text: "Documentation & Application Submission — proof of investment, clean criminal record, health insurance" },
                                { text: "Approval & Residency Permit — issued within 2–3 months" },
                                { text: "Renewals — every 2 years while investment is maintained" }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2–3 months for approval",
                            },
                            {
                                name: "Investment Thresholds",
                                description: "€500,000–€2,000,000 depending on category",
                            },
                            {
                                name: "Additional Costs",
                                description: "Legal, government, and processing fees",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in EU residency & citizenship programs" },
                                { text: "Assistance with real estate due diligence, banking, and structuring" },
                                { text: "Comparative insights: Spain vs Greece vs Italy vs Portugal" },
                                { text: "Full-service support: investment, compliance, family applications" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for European residency with lifestyle benefits?"
                        description="The Spanish Golden Visa provides Schengen mobility, family inclusion, and a path to citizenship through real estate or capital investment."
                        buttonText="Book a Golden Visa Spain Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I work in Spain with a Golden Visa?",
        content: [
            { type: "answer", text: "Yes — holders may live and work in Spain." },
        ],
    },
    {
        question: "Do I need to live in Spain full-time?",
        content: [
            { type: "answer", text: "No — you only need to visit once per year to maintain the permit." },
        ],
    },
    {
        question: "Can my family apply with me?",
        content: [
            { type: "answer", text: "Yes — spouse, children under 18 (or older if dependent), and parents." },
        ],
    },
    {
        question: "How long to citizenship?",
        content: [
            { type: "answer", text: "10 years (2 years for Ibero-American citizens)." },
        ],
    },
    {
        question: "Can I invest in multiple properties?",
        content: [
            { type: "answer", text: "Yes — as long as the total value is at least €500,000." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We obtained our Spanish Golden Visa through property investment. Offshore Advisory helped with legal structuring and the residency process.",
        author: "Ahmed H.",
        role: "Investor"
    },
    {
        quote: "Spain was the perfect choice for our family’s EU residency. Offshore Advisory guided us through property due diligence and applications.",
        author: "Lucia P.",
        role: "Entrepreneur"
    }
];

